import { API_ROUTES } from '@/constants/apiRoutes';
import { PresignedUrlRequest } from '@/types/common';
import { api } from '@/utils/api';

export const uploadPresignedUrlService = async (
  payload: PresignedUrlRequest,
) => {
  const { data } = await api<string>({
    url: `${API_ROUTES.PRESIGNED_URL}/upload`,
    method: 'post',
    version: 2,
    data: {
      type: payload.type,
      object_uuid: payload.uuid,
      file_name: payload.file,
    },
  });

  return data;
};

export const downloadPresignedUrlService = async (
  payload: PresignedUrlRequest,
) => {
  const { data } = await api<{ url: string }>({
    url: `${API_ROUTES.PRESIGNED_URL}/download`,
    method: 'post',
    version: 2,
    data: {
      type: payload.type,
      object_uuid: payload.uuid,
      file_name: payload.file,
    },
  });

  return data;
};
